import React from 'react';
import { InfoTip } from '@/pages/reports/_Components/InfoTip';
import { useReport } from '../ReportContext';

/** Says how far back each part of the report goes and how fresh it is, so missing history is not read as zero. */
const CoverageNote: React.FC<{ work?: boolean; orders?: boolean }> = ({ work = true, orders = true }) => {
  const { asOf } = useReport();
  const updated = asOf ? new Date(asOf).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : 'just now';
  const from = [work && 'work & worked: from go-live', orders && 'orders & revenue: from Jan 2022'].filter(Boolean).join(' · ');
  return (
    <InfoTip text={`Data available from: ${from}. Refreshed about every 30 minutes between 8 AM and 10 PM IST; overnight it shows the last refresh. Last updated ${updated}.`} />
  );
};

export default CoverageNote;
